/**
 * Created by r4zi4l on 05.04.2024
 */

Reward.register("wands", {
    currency: true,
    controls: "MenuBarWandsItem",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getTarget: function (value, options, source) {
        if (source && !(source instanceof cc.Node)) {
            return ["map2dWands", "wands"];
        }
        return "wands";
    },

    getFlyingAmount: function (amount) {
        if (amount <= 3) {
            return amount;
        }
        return Math.min(5, Math.floor(amount / 50) + 3);
    },

    getIcon: function () {
        return cleverapps.skins.getSlot("reward_wand_png") || bundles.reward_icons.frames.reward_wand_png;
    },

    getSmallIcon: function () {
        return cleverapps.skins.getSlot("reward_wand_small_png") || bundles.reward_icons.frames.reward_wand_small_png;
    },

    receive: function (value) {
        Map2dLocation.currentLocation.setWands(Map2dLocation.currentLocation.wands + value, true);
        return function () {
            if (Map2dLocation.currentLocation && Map2d.currentMap) {
                Map2d.currentMap.fogs.setWands(Map2dLocation.currentLocation.wands);
                Map2dLocation.currentLocation.onChangeWandsListener();
                Map2d.currentMap.fogs.wantsCalcFogStates = true;
                Map2dLocation.currentLocation.counter.setTimeout(() => {}, 0);
            }
        };
    }
});

Reward.register("worker", {
    countable: true,
    ...Reward.TimeValue,
    controls: "MenuBarWorkersItem",

    getIcon: function () {
        return cleverapps.skins.getSlot("reward_worker_png") || bundles.reward_icons.frames.reward_worker_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.worker_small_png;
    },

    receive: function (value) {
        if (this.options.toMainWorld) {
            const mainLocationId = cleverapps.meta.getMainLocationId();
            const mainSlot = cleverapps.meta.getLocationMeta(mainLocationId).locationConfig.slot;
            const workersData = mainSlot.load("workers") || {};
            const currentEnd = cleverapps.expandTime(workersData.bw, { seconds: true }) || 0;
            const newEnd = Math.max(currentEnd, Date.now()) + value.time;
            workersData.bw = cleverapps.compactTime(newEnd, { seconds: true });
            mainSlot.save("workers", workersData);
            return function () {};
        }

        if (value.subscription) {
            Map2d.currentMap.workers.addSubscriptionWorker(true);
        } else {
            Map2d.currentMap.workers.addBonusWorkerPeriod(value.time, true);
        }

        return function () {
            if (Map2d.currentMap) {
                Map2d.currentMap.workers.onChangeTotalAmount(value.amount);
            }
        };
    }
});

Reward.register("pawsPoints", {
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return cleverapps.skins.getSlot("paw_png") || bundles.reward_icons.frames.paw_png;
    },

    receive: function (value) {
        return function () {
            if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.pawBox) {
                Map2dLocation.currentLocation.pawBox.addPoints(value);
            }
        };
    }
});

RewardTypes.mission.getIcon = function (value) {
    const missionType = Mission.GetMissionType(value.missionType);
    const icon = this.icon[missionType] || Mission.getCollectIcon(missionType);
    if (icon instanceof cc.Node) {
        cleverapps.UI.fitToBox(icon, cleverapps.styles.Reward.icon);
    }
    return icon;
};

Reward.register("unit", {
    parse: function (value, options) {
        return RewardTypes.units.parse(value, options);
    }
});

// value: { code, stage, amount, pointsValue, customInfo }
Reward.register("units", {
    countable: true,
    bundle: function () {
        return Families.listLazyBundles(this.value).concat(!cleverapps.meta.getSelectedLocation().locationConfig.isMain && bundles.main_world_reward_units ? ["main_world_reward_units"] : []);
    },

    getIcon: function (value, options) {
        options = options || {};
        const icon = options.unitViewDummy ? new cc.Sprite(bundles.windows.frames.big_prize_png) : UnitView.getUnitImage(value, { alignAnchorX: true, preferStatic: true, customStatic: true });
        cleverapps.UI.fitToBox(icon, cleverapps.styles.Reward.icon);
        return icon;
    },

    getAmount: function (value) {
        return value.amount || 1;
    },

    getText: function (value, prefix) {
        return this.getPrefix(prefix) + (value.pointsValue || value.amount || 1);
    },

    getTarget: function (value, options) {
        if (options.toBubbleStack && typeof BubblesStack !== "undefined") {
            return BubblesStack.ID;
        }
        if (options.toMainWorld) {
            return "mainWorld";
        }
        return "units";
    },

    getPrice: function (value) {
        return (Families[value.code].units[value.stage].price || 0) * this.getAmount(value);
    },

    isBigReward: function (value) {
        return value.code === "coinsplant" || value.code === "rubiesplant" || value.code === "magicplant" && value.stage === 5;
    },

    sumValues: function (value, other) {
        return cleverapps.toArray(other || []).concat(cleverapps.toArray(value));
    },

    parse: function (value, options) {
        return cleverapps.toArray(value).map((unit) => new Reward("units", unit, options));
    },

    check: function (rewards, options) {
        if (options.toMainWorld) {
            return;
        }

        const amount = rewards.reduce((sum, reward) => sum + (reward.getAmount() || 1), 0);
        const notEnough = amount - Map2d.currentMap.countEmptySlots();
        if (notEnough > 0) {
            return {
                message: Messages.get("Spawn.nospace", { left: notEnough })
            };
        }
    },

    receive: function (value) {
        if (Families[value.code].type === "landmark") {
            Map2dLocation.currentLocation.landmarks.openLandmark(value);
            this.spawnedUnits = [];
            return function () {};
        }

        const centerCell = Map2d.currentMap.getScreenCenterCell();
        const units = [];

        for (let i = value.amount || 1; i > 0; --i) {
            const unit = {
                code: value.code,
                stage: value.stage,
                pointsValue: value.pointsValue,
                ...value.customInfo
            };

            units.push(unit);
        }

        if (this.options.toMainWorld) {
            const pocket = new Pocket("main");
            pocket.addUnits(units);
            return function () {
                cleverapps.toolbar.resetByType(ToolbarItem.TRAVEL_BOOK);
            };
        }

        const spawnedUnits = [];

        units.forEach((unit) => {
            const slot = Map2d.currentMap.findEmptySlot(centerCell.x, centerCell.y, unit);
            if (!slot) {
                if (Map2dLocation.currentLocation.pocket) {
                    Map2dLocation.currentLocation.pocket.addUnits(unit);
                }

                return;
            }

            unit = new Unit(unit);
            unit.setPosition(slot.x, slot.y);
            Map2d.currentMap.add(Map2d.LAYER_UNITS, slot.x, slot.y, unit);
            spawnedUnits.push(unit);
        });

        if (!this.spawnedUnits) {
            this.spawnedUnits = [];
        }

        if (spawnedUnits.length) {
            this.spawnedUnits = this.spawnedUnits.concat(spawnedUnits);
        }

        return function () {};
    }
});

// value: { code, amount }
Reward.register("harvested", {
    countable: true,
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getAmount: function (value) {
        return value.amount || 1;
    },

    parse: function (value, options) {
        return Object.keys(value).map((code) => new Reward("harvested", { code, amount: value[code] }, options));
    },

    getIcon: function (value) {
        const icon = Map2dLocation.currentLocation.harvested.getIngredientIcon(value.code);
        cleverapps.UI.fitToBox(icon, cleverapps.styles.Reward.icon);
        return icon;
    },

    receive: function (value) {
        return function () {
            if (Map2dLocation.currentLocation) {
                Map2dLocation.currentLocation.harvested.add(value.code, value.amount);
            }
        };
    }
});